<!--
 * @Author: hfxie
 * @Date: 2024-02-06 16:06:37
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-07-23 15:05:13
 * @Description: 主列表
-->
<template>
  <div 
    class="root"              
    :data-key="$store.state.initTimeStamp"
    :style="{
      '--row-height': ($store.state.rowHeight + 'px'),
      '--tree-width': (treeWidth + 'px'),
    }"
  >
      <!-- 工具栏 -->
      <div 
        class="tools"
        :data-active-search-num="activeSearchNum"
      >
        <el-input
          type="text"
          class="search-input"
          v-model="input"
          size="small"
          prefix-icon="el-icon-search"
          @input="ChangeInput"
          :placeholder="langMap.topPlaceholder"
          @keyup.enter.native="NextOrPre(1)"
          @keyup.alt.down.exact.native="NextOrPre(1)"
          @keyup.alt.up.exact.native="NextOrPre(-1)"
        >
          <i slot="suffix" class="search-detail" v-if="searchDetailShow != ''">{{searchDetailShow}}</i>
        </el-input>
        
        <!-- <i 
          class="tools-icon el-icon-location f-hide"
          @click="NextOrPre(1)"
          :class="{
            'disable': noNext,
          }"
        ></i> -->
        <i
          class="tools-icon search-pre el-icon-arrow-up"
          :class="{
            'disable': noPre,
          }"
          @click="NextOrPre(-1)"
        ></i>
        <i
          class="tools-icon search-next el-icon-arrow-down"
          :class="{
            'disable': noNext,
          }"
          @click="NextOrPre(1)"
        ></i>
      </div>
      <!-- 列表 -->
      <div
        v-if="!(sourceList instanceof Array && sourceList.length > 0)"
        class="empty-data-table"
      >
        <el-empty :image="require('../../assets/images/empty@2x.png')"></el-empty>
      </div>
      <div
        v-else
        class="content-view"
      >
        <div 
          class="content-scroll-box"
          :style="{
            'width': (contentWidth + 'px'),
          }"
        >
          <!-- 表头 -->
          <div 
            class="header"
          >
            <div class="header-name">
              {{$store.state.data.configMap?.treeName}}   
              <div class="h-line" @mousedown="ChangeItemWidth($event)">
                <div class="h-line-show"></div>
              </div>
            </div>
            <template v-for="(head, headIndex) in $store.state.data.headers">
              <div
                class="header-cell"
                :key="head.id"
                :style="{
                  'width': head.colWidth + 'px',
                  'font-size': head.fontSize + 'px',
                  'text-align': head.colAlign,
                }"
                
              >
                {{ head.colCaption }}
                <div class="h-line" @mousedown="ChangeItemWidth($event, headIndex)">
                  <div class="h-line-show"></div>
                </div>
              </div>
            </template>
          </div>
          <!-- 表体 -->
          <div
            class="content-list"
            ref="rowList"
          >
            <VirtualList
              :key="$store.state.initTimeStamp"
              :listData="showInfo.showList"
              :positions="showInfo.showList"
              :totalHeight="showInfo.totalHeight"
              :estimatedItemSize="estimatedItemSize"
              v-slot="slotProps"
              ref="vlist"
            >
              <Row
                :row="slotProps.item"
                :activeSearchNum="activeSearchNum" 
                :filteredArray="filteredArray"
              />
            </VirtualList>
          </div>
          
        </div>
      </div>
      
  </div>
</template>

<script>
import Row from "./Row/Row";
import VirtualList from "./VirtualList/VirtualList";
export default {
  name: "Root",
  data() {
    return {
      input: "",
      activeSearchNum: -1,
      filteredArray: [],
      scrollNum: 0,
      
    };
  },
  components: {
    Row,
    VirtualList,
  },
  created(){
    console.log("Root创建");
  },
  beforeDestroy(){
    console.log("Root销毁");
  },
  mounted() {
    console.log("mmc-projectTree mounted", Date.now());
  },
  /* updated() {
    console.log("mmc-projectTree updated", Date.now());
  }, */
  computed: {
    langMap(){
      return this.$store.state.langMap;
    },
    estimatedItemSize(){
      return this.$store.state.rowHeight;
    },
    treeWidth(){
      if (
        this.$store.state.data.configMap &&
        this.$store.state.data.configMap.treeWidth &&
        typeof this.$store.state.data.configMap.treeWidth == "number" &&
        this.$store.state.data.configMap.treeWidth > 0
      ){
        return this.$store.state.data.configMap.treeWidth;
      };
      console.warn("树宽参数异常", this.$store.state.data.configMap.treeWidth);
      return 250;
    },
    contentWidth(){
      const _headers = this.$store.state.data.headers;
      let total = this.treeWidth + 100;
      for(let item of _headers){
        if(typeof item.colWidth == "number" && item.colWidth > 0){
          total += item.colWidth;
        }
      }
      return total;
    },
    sourceList(){
      return this.$store.state.data.list;
    },
    /* 
      过滤后数据集合、索引下标字典，二次计算虚拟滚动位置信息
    */    
    showInfo(){
      const _sourceList = this.$store.state.data.list;
      const _expandMap = this.$store.state.expandMap;
      // 数据过滤
      let _showIndex = 0;
      let _showList = [];
      let _listMap = {} 
      for (let i = 0; i < _sourceList.length; i++) {
        const _row = _sourceList[i];
        let _isActRow = true;
        for (let _pid of _row.pids) {
          if(_expandMap[_pid]){
            // console.log("折叠", _pid, i);
            _isActRow = false;
            break;
          }
        }
        _listMap[_row.id] = {
          showIndex: (_isActRow? _showIndex: -1),
          realIndex: i,
        }
        if(_isActRow){
          // console.log(_row);
          const _posInfo = {
            _index: _showIndex,
            _id: _row.id,
            _height: this.estimatedItemSize,
            _top: this.estimatedItemSize * i,
            _bottom: this.estimatedItemSize * (i + 1),
            ..._row,
          };

          _showList.push(_posInfo);
          _showIndex++;
        }
      }

      const _info = {
        showList: _showList, // 筛选列表
        filterNum: _showIndex, // 筛选总行数
        totalHeight: _showIndex * this.estimatedItemSize, // 筛选虚拟列表总长度
        listMap: _listMap, // 筛选索引字典
        totalNum: _sourceList.length,
      }
      console.log("列表过滤", _info);
      return _info;
    },

    searchDetailShow(){
      const _input = this.input;
      if(_input == ""){
        this.activeSearchNum = -1;
        this.filteredArray = [];
        return ""
      } else {
        this.filteredArray = this.sourceList.filter(item => item.name.includes(_input));
      }
      if( this.filteredArray.length > 0){
        const _activeIndex = this.activeSearchNum > 0? this.activeSearchNum: 0;
        return `${_activeIndex + 1}/${this.filteredArray.length}`;
      }
      return "0/0";
    },
    noPre(){
      return (
        this.input == "" ||
        !(
          this.filteredArray.length > 1 &&
          this.activeSearchNum > 0 &&
          this.activeSearchNum < this.filteredArray.length
        )
      );
    },
    noNext(){
      return (
        this.input == "" ||
        this.activeSearchNum >= this.filteredArray.length - 1
      );
    },
  },
  methods: {
    ChangeInput(){
      if(this.activeSearchNum > -1) this.activeSearchNum = -1;
    },
    /**
     * @description: 搜索定位上下切换
     * @param {Number} type: -1(上), 1(下)
     * @return {*} undefined 定位到具体搜索项目可视区
     */
    NextOrPre(type = 1, desc){
      if(this.input == "" || this.filteredArray.length <= 0) return;
      const _noLoop = !true;
      if(type == -1){
        if(this.noPre){
          if(_noLoop) return;
          this.activeSearchNum = this.filteredArray.length;
        }
      } else {
        if(this.noNext){
          if(_noLoop) return;
          this.activeSearchNum = -1;
        }
      }
      // 搜索
      this.activeSearchNum += type;
      let _num = 0;
      if(this.filteredArray[this.activeSearchNum]){
        // 展开
        const _pids = this.filteredArray[this.activeSearchNum].pids;
        const _expandMap = this.$store.state.expandMap;
        for (const _key in _pids) {
          if (Object.hasOwnProperty.call(_pids, _key)) {
            const _pid = _pids[_key];
            if(_expandMap[_pid] == true){
              this.$store.commit("set_expandMap", _pid);
            }
          }
        }
        // console.log(this.showInfo, this.showInfo.listMap[this.filteredArray[this.activeSearchNum].id]);
        _num = this.showInfo.listMap[this.filteredArray[this.activeSearchNum].id]?.showIndex || 0;
      }
      // 定位
      let _rowHeight = this.$store.state.rowHeight;
      let _scrollNum = _num * _rowHeight;
      // let _clientHeight = this.$refs.rowList.clientHeight || 0;
      this.scrollNum = _scrollNum;
      this.$nextTick(()=>{
        this.$refs.vlist.$el.scrollTop = _scrollNum;
      });

    },
    ChangeItemWidth(e, _index) {
      const _self = this;
      
      const odivParent = e.currentTarget.parentNode; // 获取目标父元素
      const dx = e.clientX; // 当你第一次单击的时候，存储x轴的坐标
      const dw = odivParent.offsetWidth; // 存储默认的div的宽度
      const _offsetLeft = odivParent.offsetLeft; // 存储默认的div的距左宽度
      const _uuid = _self.$store.state.uuid;
      const _obj = {}; // 后端缓存数据
      document.getElementById(_uuid).onmousemove = _self.$utils.throttle((e) => {
        let _tableWidth = dw + (e.clientX - dx); // 最新父容器宽度
        const wbsNode = document.getElementById(_self.$store.state.uuid).getElementsByClassName("content-view")[0];
        const _wbsViewWidth = parseInt(window.getComputedStyle(wbsNode).width);
        const _wbsScrolL = wbsNode.scrollLeft;
        const max = _wbsScrolL + _wbsViewWidth - _offsetLeft; // 窗口+已滚动距离
        if (_tableWidth >= max) {
          _tableWidth = max;
        }
        const min = 50;
        if (_tableWidth <= min) {
          _tableWidth = min;
        }

        if (typeof _index == "number" && _index >= 0) {
          const _newWbsHeaderArr = _self.$utils.deepClone(_self.$store.state.data.headers);
          _newWbsHeaderArr[_index].colWidth = _tableWidth;
          _self.$store.commit("set_headers", _newWbsHeaderArr);         

          _obj.width = _tableWidth;
          _obj.index = _index;

        } else {
          _self.$store.commit("set_treeWidth", _tableWidth);
          _obj.width = _tableWidth;
        }

      }, 20, false);
      document.getElementById(_uuid).onmouseup = () => {
        document.getElementById(_uuid).onmousemove = null;
        document.getElementById(_uuid).onmouseup = null;
        // 更新后端缓存
        if (_obj.width) {
          if (typeof _index == "number" && _index >= 0) {
            _self.$store.dispatch(this.$outConst.UPDATE_HEADITEM_WIDTH, _obj);
          } else {
            _self.$store.dispatch(this.$outConst.UPDATE_TREE_WIDTH, _obj);
          }
        }
      };
      e.stopPropagation();
      e.preventDefault();
      return false;

    },
  },
};
</script>

<style scoped lang='less'>
@import './Root.less';

</style>
